import React, {Component} from "react";
import GameBoard from "./game_board";
import {config} from "../game_config";

export default class extends Component{
    render(){
        return <GameBoard height={config.height} width={config.width}/>;
    }
}